import { UserSigningMode } from '../main/constants/UserSigningMode';

export interface IExtendedProductsAccountSnakeCase {
    certificate_section: boolean;
    dcf_widget: boolean;
    new_send_display: boolean;
    multidoc_max_number: number;
    new_templates: boolean;
    new_micro_settings: boolean;
    qualified_signatures: boolean;
}
export interface IExtendedProductsUserSnakeCase {
    new_payment_page: boolean;
    signing_mode: UserSigningMode;
}

export interface IExtendedProductsSnakeCasePayload {
    account: IExtendedProductsAccountSnakeCase;
    user: IExtendedProductsUserSnakeCase;
}
export interface IExtendedProductsAccount {
    certificateSection: boolean;
    dcfWidget: boolean;
    newSendDisplay: boolean;
    multidocMaxNumber: number;
    newTemplates: boolean;
    newMicroSettings: boolean;
    qualifiedSignatures: boolean;
}
export interface IExtendedProductsUser {
    newPaymentPage: boolean;
    signingMode: UserSigningMode;
}

export interface IExtendedProductsPayload {
    account: IExtendedProductsAccount;
    user: IExtendedProductsUser;
}
export class ExtendedProducts {
    private readonly _account: IExtendedProductsAccount;
    private readonly _user: IExtendedProductsUser;

    constructor(payload: IExtendedProductsPayload) {
        this._account = payload.account;
        this._user = payload.user;
    }

    get account(): IExtendedProductsAccount {
        return this._account;
    }

    get user(): IExtendedProductsUser {
        return this._user;
    }

    public getPayload(): IExtendedProductsSnakeCasePayload {
        return {
            account: {
                certificate_section: this.account.certificateSection,
                dcf_widget: this.account.dcfWidget,
                new_send_display: this.account.newSendDisplay,
                multidoc_max_number: this.account.multidocMaxNumber,
                new_templates: this.account.newTemplates,
                new_micro_settings: this.account.newMicroSettings,
                qualified_signatures: this.account.qualifiedSignatures,
            },
            user: {
                new_payment_page: this.user.newPaymentPage,
                signing_mode: this.user.signingMode,
            },
        };
    }
}
